export default {"src":"/_next/static/media/icon-stats-resist.12f45f6e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};